<script>
  import FaqItem from './FaqItem.svelte';
  import LinkButton from './LinkButton.svelte';
  import Sectionheading from './Sectionheading.svelte';

  export let imageSrc = 'https://images.uniformhero.com.au/assets/web/faq';
  export let altText = 'custom printed uniforms';

  export let faqs = [
    {
      question: 'how does uniform hero service work?',
      answer:
        'Simply select a product, then add your design using our online design hub. Add player details and sizing. We will then print the items and ship them directly to your door.',
      show: true,
    },
    {
      question: 'how long will my order take?',
      answer:
        'Standard production time for digital printing is 10 days, for sublimation printing it is 15 days. We also offer a Rush option if you need it urgently. You can also choose from AusPost parcel or Express shipping.',
      show: false,
    },
    {
      question: 'how do I select the correct size?',
      answer:
        'The best way to determine sizing is to take an existing shirt that fits you well, lay it flat on a table and measure the half-chest. Then check that measurement against the product sizes on our website to select the best size for you. Product sizes are shown on the product pages and during the design process.',
      show: false,
    },
    {
      question: 'how can I get in touch?',
      answer: "Need more assistance? Please contact us <a href='/contact'>here</a>.",
      show: false,
    },
  ];
</script>

<div class="parent">
  <Sectionheading subheading="FREQUENTLY ASKED QUESTIONS" heading="FAQS" />

  <div class="faq">
    <div class="faq__left">
      <picture>
        <source srcset="{imageSrc}.webp" type="image/webp" />
        <source srcset="{imageSrc}.jpg" type="image/jpeg" />
        <img src="{imageSrc}.jpg" alt={altText} />
      </picture>
    </div>
    <div class="faq__right">
      <div class="faq__items">
        {#each faqs as item, i}
          <FaqItem faq={item} bind:show={faqs[i].show} />
        {/each}
      </div>
      <div class="faq-button">
        <LinkButton label="View all FAQS" type="orange" to="/faqs" />
      </div>
    </div>
  </div>
</div>

<style>
  .parent {
    padding: 2rem;
  }

  .faq {
    width: 90%;
    margin: 5rem auto 0 auto;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 5rem;
  }

  .faq__left img {
    width: 100%;
  }

  .faq__items {
    margin-bottom: 5rem;
  }

  .faq-button {
    text-align: center;
  }

  @media screen and (min-width: 800px) {
    .faq {
      grid-template-columns: repeat(2, 1fr);
      gap: 10rem;
    }
  }

  @media screen and (min-width: 1000px) {
    .faq {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media screen and (min-width: 1300px) {
    .faq {
      width: 120rem;
    }
  }
</style>
